/******/ (function() { // webpackBootstrap
var __webpack_exports__ = {};
class ReadMore extends HTMLElement {
  constructor() {
    super();
    this.toggleReadMore = this.toggleReadMore.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }
  connectedCallback() {
    this.readMoreButton = this.querySelector("[data-read-more-button]");
    this.readMoreWrapper = this.querySelector("[data-read-more-wrapper]");
    this.hasCustomEllipsis = this.hasAttribute('data-custom-ellipsis');
    this.readMoreButtonText = this.readMoreButton ? this.readMoreButton.getAttribute('data-read-more-button-text') || theme.readStrings.readMore : theme.readStrings.readMore;
    if (!this.readMoreButton && this.hasCustomEllipsis) {
      this.originalText = this.readMoreWrapper.textContent.trim();
      this.applyClickableEllipsis();
    } else if (this.readMoreButton && this.readMoreWrapper) {
      this.checkIfTruncationNeeded();
      this.readMoreButton.addEventListener('click', this.toggleReadMore);
    }
    window.addEventListener('resize', this.handleResize);
  }
  disconnectedCallback() {
    if (this.readMoreButton) {
      this.readMoreButton.removeEventListener('click', this.toggleReadMore);
    }
    window.removeEventListener('resize', this.handleResize);
  }
  handleResize() {
    if (this.hasCustomEllipsis) {
      if (!this.readMoreWrapper.classList.contains('expanded')) {
        this.readMoreWrapper.textContent = this.originalText;
        this.applyClickableEllipsis();
      }
    } else if (this.readMoreButton && this.readMoreWrapper) {
      if (!this.readMoreWrapper.classList.contains('expanded')) {
        this.checkIfTruncationNeeded();
      }
    }
  }
  checkIfTruncationNeeded() {
    const tolerance = 1;
    if (this.readMoreWrapper.scrollHeight <= this.readMoreWrapper.clientHeight + tolerance) {
      this.readMoreButton.classList.add("hidden");
    } else {
      this.readMoreButton.classList.remove("hidden");
    }
  }
  applyClickableEllipsis() {
    this.readMoreWrapper.offsetHeight;
    const tolerance = 1;
    const hasOverflow = this.readMoreWrapper.scrollHeight > this.readMoreWrapper.clientHeight + tolerance;
    if (hasOverflow) {
      this.setAttribute('data-full-text', this.originalText);
      const words = this.originalText.split(' ');
      for (let i = words.length - 1; i > 0; i--) {
        const truncatedText = words.slice(0, i).join(' ') + ' ';
        const moreSpan = '... <button data-read-more-button type="button">' + this.readMoreButtonText + '</button>';
        this.readMoreWrapper.innerHTML = truncatedText + moreSpan;
        this.readMoreWrapper.offsetHeight;
        if (this.readMoreWrapper.scrollHeight <= this.readMoreWrapper.clientHeight + tolerance) {
          this.readMoreButton = this.readMoreWrapper.querySelector("[data-read-more-button]");
          if (this.readMoreButton) {
            this.readMoreButton.addEventListener('click', this.toggleReadMore);
          }
          break;
        }
      }
    }
  }
  toggleReadMore() {
    const isExpanded = this.readMoreWrapper.classList.contains('expanded');
    if (!isExpanded) {
      const collapsedHeight = this.readMoreWrapper.offsetHeight;
      this.readMoreWrapper.style.maxHeight = collapsedHeight + 'px';
      if (this.hasCustomEllipsis) {
        const fullText = this.getAttribute('data-full-text');
        const lessSpan = ' <button data-read-more-button type="button">' + theme.readStrings.readLess + '</button>';
        this.readMoreWrapper.innerHTML = fullText + lessSpan;
        this.readMoreButton = this.readMoreWrapper.querySelector("[data-read-more-button]");
        if (this.readMoreButton) {
          this.readMoreButton.addEventListener('click', this.toggleReadMore);
        }
      } else {
        this.readMoreButton.textContent = theme.readStrings.readLess;
      }
      const expandedHeight = this.readMoreWrapper.scrollHeight;
      this.readMoreWrapper.classList.add('expanded');
      requestAnimationFrame(() => {
        this.readMoreWrapper.style.maxHeight = expandedHeight + 'px';
        setTimeout(() => {
          this.readMoreWrapper.style.maxHeight = '';
        }, 300);
      });
    } else {
      if (this.hasCustomEllipsis) {
        const currentHeight = this.readMoreWrapper.scrollHeight;
        const lineHeight = parseInt(window.getComputedStyle(this.readMoreWrapper).lineHeight) || 21;
        const targetHeight = lineHeight * 3;
        this.readMoreWrapper.style.maxHeight = currentHeight + 'px';
        requestAnimationFrame(() => {
          this.readMoreWrapper.style.transition = 'max-height 0.3s ease-in-out';
          this.readMoreWrapper.style.maxHeight = Math.max(targetHeight, lineHeight) + 'px';
          const handleTransitionEnd = e => {
            if (e.propertyName === 'max-height') {
              this.readMoreWrapper.removeEventListener('transitionend', handleTransitionEnd);
              this.readMoreWrapper.classList.remove('expanded');
              this.applyClickableEllipsis();
              this.readMoreWrapper.removeAttribute('style');
            }
          };
          this.readMoreWrapper.addEventListener('transitionend', handleTransitionEnd);
        });
      } else {
        this.readMoreWrapper.classList.remove('expanded');
        this.readMoreButton.textContent = this.readMoreButtonText;
      }
    }
  }
}
if (!customElements.get('read-more')) {
  customElements.define('read-more', ReadMore);
}
/******/ })()
;